import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  style: {"position":"absolute","top":"5px"}
}

import { ref, computed } from 'vue';
import SystemImportItemCode, { SystemImportItemName } from '../../common/code/SystemImportItemCode';

interface Props {
  id: string;
  error: boolean;
}

interface SystemItemSelect {
  label: string;
  value: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'SystemItemSelects',
  props: {
    id: {},
    error: { type: Boolean }
  },
  emits: ['selectItem'],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emit = __emit;

// 選択値
const itemSelect = computed({
  get: () => props.id,
  set: (value) => {
    emit('selectItem', value || '');
  },
});

// プルダウン内容
const options = ref<SystemItemSelect[]>([]);

/**
 * 初期処理
 */
// プルダウン内容を設定
Object.entries(SystemImportItemName).forEach(([key, value]) => {
  options.value.push({
    label: value,
    value: SystemImportItemCode[key],
  });
});

return (_ctx: any,_cache: any) => {
  const _component_q_select = _resolveComponent("q-select")!

  return (_openBlock(), _createBlock(_component_q_select, {
    modelValue: itemSelect.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((itemSelect).value = $event)),
    name: "system-item",
    options: options.value,
    outlined: "",
    clearable: "",
    dense: "",
    "emit-value": "",
    "map-options": "",
    error: props.error,
    "hide-bottom-space": "",
    style: {"background":"var(--q-white)","max-width":"400px"}
  }, {
    default: _withCtx(() => [
      (!itemSelect.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, _cache[1] || (_cache[1] = [
            _createElementVNode("span", { class: "text-dark" }, "選択してください", -1)
          ])))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["modelValue", "options", "error"]))
}
}

})